import { render, staticRenderFns } from "./Oplata.vue?vue&type=template&id=614deb2a&scoped=true&"
var script = {}
import style0 from "./Oplata.vue?vue&type=style&index=0&id=614deb2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614deb2a",
  null
  
)

export default component.exports